import { render } from "./Templates.vue?vue&type=template&id=99bd3d70&scoped=true&ts=true"
import script from "./Templates.vue?vue&type=script&lang=ts"
export * from "./Templates.vue?vue&type=script&lang=ts"

import "./Templates.vue?vue&type=style&index=0&id=99bd3d70&lang=scss&scoped=true"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99bd3d70"]])

export default __exports__